<template>
  <div>
    <div
      class="luetfrink-collapse collapsed text-secondary"
      id="collapseHeadGebaeude"
      data-toggle="collapse"
      href="#collapseGebaeude"
      role="button"
      aria-expanded="false"
      aria-controls="collapseGebaeude"
    >
      <span>Gebäude</span>
      <img
        class="luetfrink-collapse-img"
        src="../../assets/img/down.svg"
        alt="Sektion Gebaeude Collapse-Pfeil"
      />
    </div>
    <div class="collapse" id="collapseGebaeude" tabindex="-1" @focus="focusGebaeude">
      <div class="card card-body luetfrink-collapse-card">
        <div class="form-group">
          <label for="inputGebaeudehoehe">Gebäudehöhe in m (bis 25m)</label>
          <input
            v-model="gebaeudehoehe"
            v-bind:class="[(gebaeudehoehe > 25 || gebaeudehoehe < 1) && gebaeudehoehe != '' ? 'input-notallowed' : '']"
            @focus="focusGebaeude"
            type="number"
            step="0.01"
            min="1"
            max="25"
            class="form-control form-control-sm luetfrink-input"
            id="inputGebaeudehoehe"
            name="inGebaeudehoehe"
            placeholder
            value
            required
          />
        </div>
        <label>
          Geschlossenes Gebäude
          <span
            class="badge badge-pill badge-primary"
            data-toggle="tooltip"
            data-placement="top"
            title="Bei nicht geschlossenen Gebäuden ohne geschlossene Deckunterlage ist die Überprüfung durch einen Sonderfachmann notwendig!"
          >i</span>
        </label>
        <div class="custom-control custom-checkbox luetfrink-check">
          <input
            type="radio"
            value="true"
            v-model="geschlossen"
            class="custom-control-input"
            name="inCheckGeschlossen"
            id="checkGeschlossen1"
            required
          />
          <label class="custom-control-label luetfrink-check" for="checkGeschlossen1">Ja</label>
        </div>
        <div class="custom-control custom-checkbox luetfrink-check">
          <input
            type="radio"
            value="false"
            v-model="geschlossen"
            class="custom-control-input"
            name="inCheckGeschlossen"
            id="checkGeschlossen2"
            required
          />
          <label class="custom-control-label luetfrink-check" for="checkGeschlossen2">Nein</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "GebaeudeCollapse",
  methods: {
    focusGebaeude() {
      if (this.isErlaubt) {
        this.$store.commit("setActiveLink", "gebaeude");
        this.$store.commit("setActiveContent", "gebaeude");
      }
    }
  },
  computed: {
    ...mapGetters([
      "getActiveLink",
      "getActiveTrigger",
      "getActiveContent",
      "isErlaubt"
    ]),
    ...mapState({
      gebaeudehoehe: state => state.inputs.gebaeudehoehe,
      geschlossen: state => state.inputs.geschlossen
    }),
    gebaeudehoehe: {
      get() {
        return this.$store.state.inputs.gebaeudehoehe;
      },
      set(value) {
        this.$store.commit("setGebaeudehoehe", value);
      }
    },
    geschlossen: {
      get() {
        return this.$store.state.inputs.geschlossen;
      },
      set(value) {
        this.$store.commit("setGeschlossen", value);
        this.focusGebaeude();
      }
    }
  }
};
</script>

<style scoped>
</style>